import {storeToRefs} from 'pinia';
import {defineNuxtRouteMiddleware} from '#app';
import {safelyNavigateTo} from '@malt/utils';
import {UrlAction, useRedirectParamsStore} from '~/store/redirect-params.store';

export default defineNuxtRouteMiddleware(() => {
    const redirectParamsStore = useRedirectParamsStore();
    const {action, successRedirect, dropRedirect, source} = storeToRefs(redirectParamsStore);

    redirectParamsStore.setRedirectUrl();

    const queryString = (urlAction: UrlAction) =>
        new URLSearchParams({
            action: urlAction,
            successRedirectPath: successRedirect.value ?? '',
            dropRedirectPath: dropRedirect.value ?? '',
            pageSource: source.value ?? '',
        }).toString();

    if (action.value === UrlAction.PhoneNumberMissing || action.value === UrlAction.PhoneNumberMissingAndNeedValidation) {
        return safelyNavigateTo(`/security-check/phone?${queryString(action.value)}`);
    }

    if (action.value === UrlAction.PhoneNumberNeedValidation) {
        return safelyNavigateTo(`/security-check/code?${queryString(action.value)}`);
    }

    return safelyNavigateTo('/phone');
});
